export default "__VITE_ASSET__BWrY4mv3__"